{
  "header": {
    "title": "Führungs-Einblicke",
    "description": "Tauchen Sie in Feedback für verschiedene Führungskräfte ein",
    "exportButton": "Exportieren"
  },
  "emptyState": {
    "company": {
      "title": "Noch keine Daten gesammelt",
      "description": "Ihre Reise beginnt hier! Sobald Mitarbeiter im ersten Monat Feedback geben, sehen Sie Einblicke und Trends."
    },
    "directReports": {
      "title": "Keine direkte Berichtsebene",
      "description": "Ihnen sind keine direkten Berichte zugewiesen, aber Sie können trotzdem an Umfragen teilnehmen und wertvolles Feedback geben!",
      "bottomAction": {
        "label": "Wenn Sie denken, dass dies ein Fehler ist, kontaktieren Sie Ihren Vorgesetzten",
        "helpText": "Hilfetext"
      }
    }
  },
  "datePicker": {
    "currentMonth": "Dieser Monat",
    "lastMonth": "Letzter Monat",
    "monthCount": "Vor {{monthCount}} Monaten"
  },
  "leaderDropdown": {
    "triggerLabel": "Führungskraft",
    "searchPlaceholder": "Führungskraft finden"
  },
  "columnDropdown": {
    "triggerLabel": "Spalten",
    "options": {
      "showAll": "Alle Spalten anzeigen",
      "hideAll": "Alle Spalten ausblenden"
    }
  },
  "departmentDropdown": {
    "triggerLabel": "Abteilung"
  },
  "tabs": {
    "allReports": "Alle Berichte",
    "directReports": "Direkte Berichte"
  },
  "columns": {
    "leaderName": "Name der Führungskraft",
    "department": "Abteilung",
    "averageScore": "Durchschnittliche Bewertung",
    "enps": "eNPS",
    "reportCount": "Anzahl der Berichte",
    "participationRate": "Teilnahmerate"
  },
  "loadMoreButton": "Lade mehr Daten",
  "labels": {
    "leader": "Führungskraft",
    "noResults": "Keine Ergebnisse"
  },
  "help": {
    "noResults": "Keine Ergebnisse gefunden"
  },
  "loadingMoreData": "Weitere Daten werden geladen",
  "leaderInsightsDetailsSection": {
    "name": "Führungskraft",
    "department": "Abteilung",
    "averageScore": "Durchschnittliche Punktzahl",
    "enps": "eNPS",
    "reportCount": "Anzahl Berichte",
    "participationRate": "Teilnahmequote"
  },
  "detailsPage": {
    "header": {
      "name": "{{name}} Team",
      "department": "{{department}} Team",
      "backButton": "Zurück zu Führungs-Einblicken",
      "seeProfileButton": "Profil ansehen",
      "exportButton": "Exportieren"
    },
    "tabs": {
      "allReports": "Alle Berichte",
      "directReports": "Direkte Berichte"
    },
    "leaderMetrics": {
      "title": "Metriken der Führungskraft",
      "category": {
        "enps": {
          "name": "eNPS",
          "helpText": "Hilfetext"
        },
        "averageScore": {
          "name": "Durchschnittliche Bewertung",
          "helpText": "Hilfetext"
        },
        "participationRate": {
          "name": "Team-Teilnahmerate",
          "helpText": "Hilfetext"
        }
      },
      "chart": {
        "title": "Arbeitszufriedenheitswert"
      }
    },
    "teamMetrics": {
      "title": "Durchschnittliche Team-Metriken",
      "scoreTitle": "{{name}}'s Team",
      "companyAverageTitle": "Firmen-Durchschnitt"
    },
    "keysInsights": {
      "title": "Wichtige Erkenntnisse",
      "strengths": {
        "title": "Stärken",
        "tooltipTitle": "Hilfetext"
      },
      "growthAreas": {
        "title": "Wachstumsbereiche",
        "tooltipTitle": "Hilfetext"
      }
    },
    "directReport": {
      "title": "Direkte Berichtsebene Führungskräfte",
      "empty": {
        "title": "Keine direkt unterstellten Führungskräfte",
        "description": "Dieser Leader hat keine untergeordneten Führungskräfte, oder die Daten wurden noch nicht geladen."
      }
    }
  }
}
